import { Container } from "inversify";
import TokenRepo from "@/core/repos/token.repo";
import ApiRepo from "@/core/repos/api.repo";
import AuthRepo from "@/core/repos/auth.repo";
import { TollAreaRepo } from "@/core/repos/tables/toll-area.repo";
import { UserRepo } from "@/core/repos/user.repo";
import { WaterRegistrationRepo } from "@/core/repos/tables/water-registration.repo";
import { ContractRepo } from "@/core/repos/tables/contract.repo";
import { UnitTypeRepo } from "@/core/repos/tables/unit-type.repo";
import { TransactionRepo } from "@/core/repos/tables/transaction.repo";
import { MediaRepo } from "@/core/repos/tables/media.repo";
import { SampleTestRepo } from "@/core/repos/tables/sample-test.repo";
import { ReadMeterPeriodRepo } from "@/core/repos/tables/read-meter-period.repo";
import { TopUpTransactionRepo } from "@/core/repos/tables/top-up-transaction.repo";
import { UserRequestRepo } from "@/core/repos/tables/user-request.repo";
import { NotificationRepo } from "@/core/repos/tables/notification.repo";
import { WaterIndexRepo } from "@/core/repos/tables/water-index.repo";
import { WaterInvoiceRepo } from "@/core/repos/tables/water-invoice.repo";
import { WaterSupplySuspensionRepo } from "@/core/repos/tables/water-supply-suspension.repo";
import { WaterSupplySuspensionLevelRepo } from "@/core/repos/tables/water-supply-suspension-level.repo";
import { FeeLadderLevelRepo } from "@/core/repos/tables/fee-ladder-level.repo";
import { FeeLadderRepo } from "@/core/repos/tables/fee-ladder.repo";
import { ServiceRepo } from "@/core/repos/tables/service.repo";
import { ServiceUserManualRepo } from "@/core/repos/tables/service-user-manual.repo";
import { AppUserRepo } from "@/core/repos/tables/app-user.repo";
import { AppRoleRepo } from "@/core/repos/tables/app-role.repo";
import { AuditLogRepo } from "@/core/repos/tables/audit-log.repo";
import { FactoryBillingRepo } from "@/core/repos/tables/factory-billing.repo";
import { WaterMeterRepo } from "@/core/repos/tables/water-meter.repo";
import { WaterMeterChangeRepo } from "@/core/repos/tables/water-meter-change.repo";
import { AddressRepo } from "@/core/repos/address.repo";
import { DepartmentRepo } from "@/core/repos/tables/department.repo";
import ConfigRepo from "@/core/repos/config.repo";
import { WaterFactoryRepo } from "@/core/repos/tables/water-factory.repo";
import { PaymentPointRepo } from "@/core/repos/tables/payment-point.repo";
import { ElectronicContractRepo } from "@/core/repos/tables/electronic-contract.repo";
import { ArticleRepo } from "@/core/repos/tables/article.repo";
import { CategoryArticleRepo } from "@/core/repos/tables/category-article.repo";
import { PaymentOutboxRepo } from "@/core/repos/tables/payment-outbox.repo";

import { ResellerDiscountPolicyRepo } from "@/core/repos/tables/reseller-discount-policy.repo";

const container = new Container();

container.bind(TokenRepo).to(TokenRepo).inSingletonScope();
container.bind(AuthRepo).to(AuthRepo).inSingletonScope();
container.bind(ApiRepo).to(ApiRepo).inSingletonScope();
container.bind(TollAreaRepo).to(TollAreaRepo).inSingletonScope();
container.bind(WaterRegistrationRepo).to(WaterRegistrationRepo).inSingletonScope();
container.bind(ContractRepo).to(ContractRepo).inSingletonScope();
container.bind(ResellerDiscountPolicyRepo).to(ResellerDiscountPolicyRepo).inSingletonScope();
container.bind(UnitTypeRepo).to(UnitTypeRepo).inSingletonScope();
container.bind(AddressRepo).to(AddressRepo).inSingletonScope();
container.bind(UserRepo).to(UserRepo).inSingletonScope();
container.bind(ReadMeterPeriodRepo).to(ReadMeterPeriodRepo).inSingletonScope();
container.bind(TopUpTransactionRepo).to(TopUpTransactionRepo).inSingletonScope();
container.bind(UserRequestRepo).to(UserRequestRepo).inSingletonScope();
container.bind(NotificationRepo).to(NotificationRepo).inSingletonScope();
container.bind(TransactionRepo).to(TransactionRepo).inSingletonScope();
container.bind(MediaRepo).to(MediaRepo).inSingletonScope();
container.bind(SampleTestRepo).to(SampleTestRepo).inSingletonScope();
container.bind(WaterInvoiceRepo).to(WaterInvoiceRepo).inSingletonScope();
container.bind(WaterIndexRepo).to(WaterIndexRepo).inSingletonScope();
container.bind(WaterSupplySuspensionRepo).to(WaterSupplySuspensionRepo).inSingletonScope();
container.bind(WaterSupplySuspensionLevelRepo).to(WaterSupplySuspensionLevelRepo).inSingletonScope();
container.bind(DepartmentRepo).to(DepartmentRepo).inSingletonScope();
container.bind(FeeLadderLevelRepo).to(FeeLadderLevelRepo).inSingletonScope();
container.bind(FeeLadderRepo).to(FeeLadderRepo).inSingletonScope();
container.bind(ServiceRepo).to(ServiceRepo).inSingletonScope();
container.bind(ServiceUserManualRepo).to(ServiceUserManualRepo).inSingletonScope();
container.bind(AppUserRepo).to(AppUserRepo).inSingletonScope();
container.bind(AppRoleRepo).to(AppRoleRepo).inSingletonScope();
container.bind(AuditLogRepo).to(AuditLogRepo).inSingletonScope();
container.bind(FactoryBillingRepo).to(FactoryBillingRepo).inSingletonScope();
container.bind(WaterMeterRepo).to(WaterMeterRepo).inSingletonScope();
container.bind(WaterMeterChangeRepo).to(WaterMeterChangeRepo).inSingletonScope();
container.bind(ConfigRepo).to(ConfigRepo).inSingletonScope();
container.bind(WaterFactoryRepo).to(WaterFactoryRepo).inSingletonScope();
container.bind(PaymentPointRepo).to(PaymentPointRepo).inSingletonScope();
container.bind(ElectronicContractRepo).to(ElectronicContractRepo).inSingletonScope();
container.bind(ArticleRepo).to(ArticleRepo).inSingletonScope();
container.bind(CategoryArticleRepo).to(CategoryArticleRepo).inSingletonScope();
container.bind(PaymentOutboxRepo).to(PaymentOutboxRepo).inSingletonScope();

export default container;